// SME Courses
export const FETCH_SME_COURSES_REQUEST = 'FETCH_SME_COURSES_REQUEST';
export const FETCH_SME_COURSES_SUCCESS = 'FETCH_SME_COURSES_SUCCESS';
export const FETCH_SME_COURSES_FAILURE = 'FETCH_SME_COURSES_FAILURE';

// Course Contents
export const FETCH_SME_COURSE_CONTENTS_REQUEST = 'FETCH_SME_COURSE_CONTENTS_REQUEST';
export const FETCH_SME_COURSE_CONTENTS_SUCCESS = 'FETCH_SME_COURSE_CONTENTS_SUCCESS';
export const FETCH_SME_COURSE_CONTENTS_FAILURE = 'FETCH_SME_COURSE_CONTENTS_FAILURE';

// Create Content
export const CREATE_SME_CONTENT_REQUEST = 'CREATE_SME_CONTENT_REQUEST';
export const CREATE_SME_CONTENT_SUCCESS = 'CREATE_SME_CONTENT_SUCCESS';
export const CREATE_SME_CONTENT_FAILURE = 'CREATE_SME_CONTENT_FAILURE';

// Update Content
export const UPDATE_SME_CONTENT_REQUEST = 'UPDATE_SME_CONTENT_REQUEST';
export const UPDATE_SME_CONTENT_SUCCESS = 'UPDATE_SME_CONTENT_SUCCESS';
export const UPDATE_SME_CONTENT_FAILURE = 'UPDATE_SME_CONTENT_FAILURE';

// Delete Content
export const DELETE_SME_CONTENT_REQUEST = 'DELETE_SME_CONTENT_REQUEST';
export const DELETE_SME_CONTENT_SUCCESS = 'DELETE_SME_CONTENT_SUCCESS';
export const DELETE_SME_CONTENT_FAILURE = 'DELETE_SME_CONTENT_FAILURE';

// Content Statistics
export const FETCH_SME_CONTENT_STATS_REQUEST = 'FETCH_SME_CONTENT_STATS_REQUEST';
export const FETCH_SME_CONTENT_STATS_SUCCESS = 'FETCH_SME_CONTENT_STATS_SUCCESS';
export const FETCH_SME_CONTENT_STATS_FAILURE = 'FETCH_SME_CONTENT_STATS_FAILURE';

// Fetch Single Content by ID
export const FETCH_SME_CONTENT_BY_ID_REQUEST = 'FETCH_SME_CONTENT_BY_ID_REQUEST';
export const FETCH_SME_CONTENT_BY_ID_SUCCESS = 'FETCH_SME_CONTENT_BY_ID_SUCCESS';
export const FETCH_SME_CONTENT_BY_ID_FAILURE = 'FETCH_SME_CONTENT_BY_ID_FAILURE';

// Clear Errors
export const CLEAR_SME_CONTENT_ERROR = 'CLEAR_SME_CONTENT_ERROR';
